import { useState, useMemo } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { useFetchResourcesByIdsQuery } from "@shared/services/queries";
import { ApiResponse } from "@shared/types";
import { Store } from "@modules/stores/types";
import { Company } from "@modules/companies/types";

export function useStoresList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Store>({
    resource: "v1/store_admin",
    filters: getQueryParams(),
    sorters: { ordering: "-id" },
  });

  const companiesIds = useMemo(
    () => [...new Set(rows?.map((store) => store.company).filter((id): id is number => !!id))],
    [rows]
  );

  const { data: companies } = useFetchResourcesByIdsQuery<ApiResponse<Company>>({
    resource: "v1/company_admin",
    ids: companiesIds,
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    companies: companies?.results,

    refetch,
    setSelectedRows,
    translate,

  };
}
